export default "__VITE_ASSET__DLQgzq$4__"